import { Injectable } from '@angular/core';
import { defaultDwopenEndpoint, defaultMapsHost, environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

    get prefixKey() : string { return this.cookieService.get("app-center-instance"); }

    get appCenterUrl() : string {return this.prefixKey ? environment.instances[this.prefixKey]?.appCenter : null }
    get appCenterCurrentInstance() { return this.prefixKey ?  environment.instances[this.prefixKey]?.name : null }
    get appCenterInstanceUrl() { return this.prefixKey ? environment.instances[this.prefixKey]?.instancesUrl : null }
    get appCenterLnfUrl() { return this.prefixKey ? environment.instances[this.prefixKey]?.lnfUrl : null }
    get appCenterEndpoint() {
        return this.prefixKey && (environment.instances[this.prefixKey]?.endpoint)
        ? environment.instances[this.prefixKey].endpoint : defaultDwopenEndpoint;
    }

    /**
     * Absolute host (scheme + domain, no trailing slash) of the dwportal Maps
     * API for the current instance, e.g. 'https://engr.devicewise.com'.
     * MUST be absolute: the built CMP JS is deployed to a CDN with no
     * server-side proxy, so relative '/maps/*' paths only work under
     * `ng serve` locally (proxy.conf.js) and break in every deployed build.
     */
    get mapsHost(): string {
        return this.prefixKey && environment.instances[this.prefixKey]?.mapsHost
            ? environment.instances[this.prefixKey].mapsHost
            : defaultMapsHost;
    }

    get connectedApps(){
        return this.prefixKey ? environment.instances[this.prefixKey]?.connectedApps : {};
    }

    constructor(private cookieService: CookieService) { }
}
